import { get } from 'lodash'
import ArticleListMixin from '~/mixins/ArticleListMixin'
import HeaderConfigurationMixin from '~/mixins/HeaderConfigurationMixin'
import MenuItemPageMixin from '~/mixins/MenuItemPageMixin'
import SeoMixin from '~/mixins/SeoMixin'

export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
    headerConfiguration: null,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          title: this.$t('PageArticleListCategory.breadcrumbs.index'),
          path: this.localePath({ name: 'articleList' }),
        },
        ...this.menuBreadcrumbs,
      ]
    },
    getCategoryData() {
      return {
        description:
          get(this.category, 'content[0].value[' + this.$store.state.locale.contentLocale + ']') ||
          this.getHeaderData.description,
        image: {
          alt: get(this.category, 'image.[0].alt') || this.getHeaderData.image.alt,
          path: get(this.category, 'image[0].path') || this.getHeaderData.image.path,
        },
        title: get(this.category, 'title') || this.getHeaderData.title,
        perex: get(this.category, 'perex') || this.getHeaderData.perex,
      }
    },
    showHeader() {
      return (
        this.$themeSettings.components.PageArticleListCategory.header.enable &&
        (this.$themeSettings.components.ContentHeader.image.required === false ||
          (this.$themeSettings.components.ContentHeader.image.required && this.getCategoryData.image.path))
      )
    },
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageArticleListCategory' })
  },
  mixins: [ArticleListMixin, HeaderConfigurationMixin, MenuItemPageMixin, SeoMixin],
}
